var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCarbon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_722_6508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.332 20.5C10.332 14.9772 14.8092 10.5 20.332 10.5H30.332C35.8549 10.5 40.332 14.9772 40.332 20.5V40.5H20.332C14.8092 40.5 10.332 36.0228 10.332 30.5V20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_6508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9933 23.9482L25.6183 21.9514C25.5317 21.9 25.4327 21.8729 25.332 21.873C25.2312 21.8731 25.1323 21.9004 25.0457 21.9519L21.6707 23.9488C21.5866 23.9984 21.5168 24.0692 21.4684 24.154C21.42 24.2388 21.3945 24.3349 21.3945 24.4325V28.3138C21.3945 28.5129 21.4997 28.6969 21.6707 28.7975L25.0457 30.7944C25.1322 30.8463 25.2312 30.8738 25.332 30.8738C25.4329 30.8738 25.5319 30.8463 25.6183 30.7944L28.9933 28.7975C29.0775 28.7479 29.1472 28.6772 29.1957 28.5923C29.2441 28.5075 29.2696 28.4115 29.2695 28.3138V24.4325C29.2696 24.3348 29.2441 24.2387 29.1957 24.1538C29.1472 24.0688 29.0775 23.998 28.9933 23.9482ZM28.1445 27.9932L25.332 29.657L22.5195 27.9932V24.7532L25.332 23.0893L28.1445 24.7532V27.9932Z",
    fill: "url(#paint0_linear_722_6508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.707 28.164V23.0374L23.1945 20.9764L22.6225 20.0078L18.8582 22.2325C18.7741 22.2822 18.7043 22.3531 18.6559 22.438C18.6075 22.5229 18.582 22.619 18.582 22.7168V28.164C18.254 28.2797 17.9697 28.494 17.7683 28.7776C17.5669 29.0612 17.4581 29.4002 17.457 29.748C17.457 30.6784 18.2142 31.4355 19.1445 31.4355C20.0749 31.4355 20.832 30.6784 20.832 29.748C20.8309 29.4002 20.7222 29.0612 20.5208 28.7776C20.3193 28.494 20.0351 28.2797 19.707 28.164ZM19.1445 30.3105C18.9997 30.3041 18.8629 30.242 18.7627 30.1372C18.6626 30.0324 18.6066 29.893 18.6066 29.748C18.6066 29.6031 18.6626 29.4637 18.7627 29.3589C18.8629 29.2541 18.9997 29.192 19.1445 29.1855C19.2894 29.192 19.4261 29.2541 19.5263 29.3589C19.6265 29.4637 19.6824 29.6031 19.6824 29.748C19.6824 29.893 19.6265 30.0324 19.5263 30.1372C19.4261 30.242 19.2894 30.3041 19.1445 30.3105ZM31.5195 28.0605C30.5892 28.0605 29.832 28.8177 29.832 29.748C29.832 29.9466 29.8725 30.1345 29.9361 30.3117L25.332 33.0319L21.7298 30.9034L21.1577 31.872L25.0457 34.1693C25.1323 34.2208 25.2312 34.2481 25.332 34.2482C25.4327 34.2483 25.5316 34.2212 25.6183 34.1699L30.6583 31.1914C30.9115 31.3427 31.204 31.4355 31.5195 31.4355C32.4499 31.4355 33.207 30.6784 33.207 29.748C33.207 28.8177 32.4499 28.0605 31.5195 28.0605ZM31.5195 30.3105C31.3747 30.3041 31.2379 30.242 31.1377 30.1372C31.0376 30.0324 30.9816 29.893 30.9816 29.748C30.9816 29.6031 31.0376 29.4637 31.1377 29.3589C31.2379 29.2541 31.3747 29.192 31.5195 29.1855C31.6644 29.192 31.8011 29.2541 31.9013 29.3589C32.0015 29.4637 32.0574 29.6031 32.0574 29.748C32.0574 29.893 32.0015 30.0324 31.9013 30.1372C31.8011 30.242 31.6644 30.3041 31.5195 30.3105ZM25.332 20.748C25.7432 20.748 26.115 20.5945 26.4081 20.3498L30.957 23.038V26.9355H32.082V22.7168C32.0821 22.619 32.0566 22.5229 32.0082 22.438C31.9597 22.3531 31.89 22.2822 31.8058 22.2325L26.9869 19.3851C27.0072 19.2799 27.0195 19.1719 27.0195 19.0605C27.0195 18.1302 26.2624 17.373 25.332 17.373C24.4017 17.373 23.6445 18.1302 23.6445 19.0605C23.6445 19.9909 24.4017 20.748 25.332 20.748ZM25.332 18.498C25.4434 18.4979 25.5524 18.5309 25.6451 18.5927C25.7377 18.6545 25.81 18.7425 25.8527 18.8454C25.8954 18.9483 25.9066 19.0615 25.8849 19.1708C25.8632 19.2801 25.8095 19.3805 25.7307 19.4593C25.652 19.538 25.5516 19.5917 25.4423 19.6134C25.333 19.6351 25.2198 19.6239 25.1169 19.5812C25.0139 19.5385 24.926 19.4663 24.8642 19.3736C24.8024 19.2809 24.7694 19.172 24.7695 19.0605C24.7695 18.75 25.0221 18.498 25.332 18.498Z",
    fill: "url(#paint1_linear_722_6508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3486 22.4766L21.8594 24.4489L22.2382 28.2797L25.3486 30.0624L28.6861 28.0901V24.7144L25.3486 22.4766Z",
    fill: "url(#paint2_linear_722_6508)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_722_6508",
    x: 0.332031,
    y: 0.5,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.589833 0 0 0 0 0.108333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_722_6508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_722_6508",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_6508",
    x1: 21.3945,
    y1: 26.3734,
    x2: 29.2695,
    y2: 26.3734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_722_6508",
    x1: 17.457,
    y1: 25.8106,
    x2: 33.207,
    y2: 25.8106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_722_6508",
    x1: 21.8594,
    y1: 26.2695,
    x2: 28.6861,
    y2: 26.2695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_6508"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.332 25.8105C16.332 20.84 20.3615 16.8105 25.332 16.8105C30.3026 16.8105 34.332 20.84 34.332 25.8105V34.8105H25.332C20.3615 34.8105 16.332 30.7811 16.332 25.8105Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCarbon);
export default __webpack_public_path__ + "static/media/ico-carbon.b209a7ef98b63997442b0b90b26811b9.svg";
export { ForwardRef as ReactComponent };